import styled from '@emotion/styled/macro';

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ButtonWrapper = styled.div`
    height: 48px;
    width: 100%;
    max-width: 343px;
    display: flex;
    margin: 0 auto;
`;
